<template>
  <v-dialog v-model="showDialog" persistent max-width="500">
    <v-card class="success-dialog-card">
      <v-card-title
        v-if="heading"
        style="background-color: #f5f5f5; padding-bottom: 6px; padding-top: 6px"
      >
        <span class="headline2">{{ heading }} </span></v-card-title
      >
      <v-card-text>
        <div class="heading py-3 px-3">
          {{ content || "Successful" }}
          <v-icon color="orange" small>check_circle</v-icon>
        </div>
      </v-card-text>
      <v-card-actions class="success-dialog-actions">
        <v-spacer></v-spacer>
        <v-btn
          class="success-dialog-ok oms-dialog-action--primary oms-btn oms-btn--primary"
          color="#ea7a1c"
          @click.native="closeDialog"
        >
          Ok
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    content: String,
    heading: String,
    show: {
      type: Boolean,
      default: false,
    },
    onclose: Function,
  },
  data() {
    return {
      showDialog: this.show,
    };
  },
  watch: {
    show(val) {
      this.showDialog = val;
    },
  },
  methods: {
    closeDialog() {
      this.showDialog = false;
      if (typeof this.onclose === "function") {
        this.onclose();
      }
    },
  },
};
</script>

<style>
.v-card__title span.headline2 {
  font-size: 20px !important;
}

.success-dialog-card {
  border: 1px solid var(--oms-border, #e6e2d8) !important;
  border-radius: 0.875rem !important;
  box-shadow: 0 1rem 2.25rem rgba(17, 24, 39, 0.16) !important;
  overflow: hidden;
}

.success-dialog-actions {
  background: var(--oms-surface-soft, #faf9f6);
  border-top: 1px solid var(--oms-border, #e6e2d8);
  padding: 0.875rem 1rem !important;
}

.application .v-dialog .success-dialog-card .success-dialog-ok.v-btn,
.success-dialog-card .success-dialog-ok.v-btn,
.success-dialog-ok.v-btn {
  align-items: center;
  background: var(--oms-primary, #ea7a1c) !important;
  border: 0.09375rem solid var(--oms-primary, #ea7a1c) !important;
  border-radius: var(--oms-control-radius, 0.625rem) !important;
  box-shadow: 0 0.125rem 0.5rem rgba(245, 130, 32, 0.25) !important;
  color: #ffffff !important;
  display: inline-flex;
  font-size: 0.75rem !important;
  font-weight: 700 !important;
  height: var(--oms-control-height, 2.375rem) !important;
  justify-content: center;
  letter-spacing: 0 !important;
  line-height: 1 !important;
  min-height: var(--oms-control-height, 2.375rem) !important;
  min-width: 4.75rem !important;
  padding: 0 1rem !important;
  text-transform: none !important;
}

.application .v-dialog .success-dialog-card .success-dialog-ok.v-btn::before,
.success-dialog-card .success-dialog-ok.v-btn::before,
.success-dialog-ok.v-btn::before {
  background-color: transparent !important;
}

.application .v-dialog .success-dialog-card .success-dialog-ok.v-btn .v-btn__content,
.success-dialog-card .success-dialog-ok.v-btn .v-btn__content,
.success-dialog-ok.v-btn .v-btn__content {
  align-items: center;
  color: #ffffff !important;
  display: inline-flex;
  justify-content: center;
}

.application .v-dialog .success-dialog-card .success-dialog-ok.v-btn:hover,
.application .v-dialog .success-dialog-card .success-dialog-ok.v-btn:focus,
.success-dialog-card .success-dialog-ok.v-btn:hover,
.success-dialog-card .success-dialog-ok.v-btn:focus,
.success-dialog-ok.v-btn:hover,
.success-dialog-ok.v-btn:focus {
  background: var(--oms-primary-dark, #d96a10) !important;
  border-color: var(--oms-primary-dark, #d96a10) !important;
}
</style>
